export default __webpack_public_path__ + "assets/insets14.png";